export function createSnow(numFlakes: number): void {
  const snowContainer = document.getElementById("snow-container");
  
  if (!snowContainer) {
    return;
  }

  
  for (let i = 0; i < numFlakes; i++) {
    let snowDiv = document.createElement("div");
    snowDiv.classList.add("snow");

    const size = Math.random() * (5 -1) + 1; // snow size between 1px and 5px
    snowDiv.style.width = `${size}px`;
    snowDiv.style.height = `${size}px`;
    snowDiv.style.opacity = `${Math.random()}`; // random opacity between 0 and 1
    snowDiv.style.animationDuration = `${Math.random() * (15000 - 10000) + 5000}ms`; // random duration between 1s and 3s
    snowContainer.prepend(snowDiv);
  }

}

document.addEventListener("DOMContentLoaded", () => createSnow(200));